import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import NuevaOrden     from './pages/NuevaOrden';
import Clientes       from './pages/Clientes';
import Ordenes        from './pages/Ordenes';
import Presupuestos   from './pages/Presupuestos';
import ImportarFixed  from './pages/ImportarFixed';
import Configuracion  from './pages/Configuracion';
import Catalogo       from './pages/Catalogo';
import ImportarCatalogoML from './pages/ImportarCatalogoML';
import Login           from './pages/Login';
import ChequeoPrecompra from './pages/ChequeoPrecompra';
import RevisionGeneral from './pages/RevisionGeneral';

export default function App() {
  const [usuario, setUsuario] = useState(() => localStorage.getItem('iunic_usuario'));

  if (!usuario) {
    return <Login onLogin={setUsuario} />;
  }

  function salir() {
    localStorage.removeItem('iunic_token');
    localStorage.removeItem('iunic_usuario');
    setUsuario(null);
  }

  return (
    <BrowserRouter>
      <div className="app-shell">
        <nav className="topbar">
          <span className="topbar-logo">
            <img src="/assets/logo.png" alt="IUNIC Motors" />
          </span>
          <div className="topbar-nav">
            <NavLink to="/"        end>Nueva orden</NavLink>
            <NavLink to="/ordenes"    >Órdenes</NavLink>
            <NavLink to="/presupuestos">Presupuestos</NavLink>
            <NavLink to="/chequeos">Chequeo precompra</NavLink>
            <NavLink to="/revisiones">Revisión general</NavLink>
            <NavLink to="/clientes"   >Clientes</NavLink>
            <NavLink to="/catalogo">Catálogo</NavLink>
            <NavLink to="/importar-fixed">Facturas</NavLink>
            <NavLink to="/configuracion">⚙️</NavLink>
            <button onClick={salir} style={{ marginLeft: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit' }}>
              Salir ({usuario})
            </button>
          </div>
        </nav>

        <Routes>
          <Route path="/"          element={<NuevaOrden />} />
          <Route path="/ordenes"   element={<Ordenes />} />
          <Route path="/presupuestos" element={<Presupuestos />} />
          <Route path="/chequeos" element={<ChequeoPrecompra />} />
          <Route path="/revisiones" element={<RevisionGeneral />} />
          <Route path="/clientes"  element={<Clientes />} />
          <Route path="/catalogo"  element={<Catalogo />} />
          <Route path="/catalogo/importar-ml" element={<ImportarCatalogoML />} />
          <Route path="/importar-fixed" element={<ImportarFixed />} />
          <Route path="/configuracion" element={<Configuracion />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
